import { TasdekRequester } from '@/models/ExternalTasdek/TasdekRequester';
import { TasdekParty } from './../../models/ExternalTasdek/TasdekParty';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';
import { TasdekRequestDetail } from '@/models/ExternalTasdek/TasdekRequestDetail';
import { ExternalTasdekPartyType } from '@/components/ExternalTasdek/Enums/ExternalTasdekSteps';
import { TasdekCountries } from '@/shared/components/IdentityTypesComponents/Model/NationalityModel';

//@Module({ namespaced: true })
@Module({})
export default class ExternalTasdekStore extends VuexModule {
  tasdekModel: TasdekRequestDetail = {} as TasdekRequestDetail;


  get getTasdekModel(): TasdekRequestDetail {
    return this.tasdekModel;
  }



  @Mutation
  public setTasdekModelMut(model: TasdekRequestDetail): void {
    this.tasdekModel = model;
  }

  @Mutation
  public addTasdekSecondPartyMut(model: TasdekParty): void {
    this.tasdekModel.partiesList.push(model);
  }

  @Mutation
  public addTasdekFirstPartyMut(model: TasdekParty): void {
    this.tasdekModel.partiesList.push(model);
  }

  @Mutation
  public removeTasdekPartyMut(model: TasdekParty): void {
    this.tasdekModel.partiesList.splice(
      this.tasdekModel.partiesList.indexOf(model),
      1
    );
  }

  @Mutation
  public setTasdekRequesterMut(model: TasdekRequester): void {
    this.tasdekModel.requester = model;
  }

  @Mutation
  public setIsExistedWakalahNoMut(value: boolean): void {
    this.tasdekModel.isExistedWakalahNo = value;
  }

  @Mutation
  public clearTasdekMut(): void {
    this.tasdekModel = {} as TasdekRequestDetail;
  }



  @Action
  public clearTasdekAction(): void {
    this.context.commit('clearTasdekMut');
  }

  @Action
  public setTasdekModel(model: TasdekRequestDetail): void {
    this.context.commit('setTasdekModelMut', model);
  }

  @Action
  public addTasdekSecondParty(model: TasdekParty): void {
    this.context.commit('addTasdekSecondPartyMut', model);
  }

  @Action
  public addTasdekFirstParty(model: TasdekParty): void {
    this.context.commit('addTasdekFirstPartyMut', model);
  }

  @Action
  public removeTasdekParty(model: TasdekRequestDetail): void {
    this.context.commit('setTasdekModelMut', model);
  }

  @Action
  public setTasdekRequester(model: TasdekRequester): void {
    this.context.commit('setTasdekRequesterMut', model);
  }

  @Action
  public setIsExistedWakalahNo(value: boolean): void {
    this.context.commit('setIsExistedWakalahNoMut', value);
  }



}
